import {useEffect} from "react"
import PropTypes from "prop-types"
import {Link} from "react-router-dom"
import {Row, Col, Spinner} from "reactstrap"
import {useDispatch, useSelector} from "react-redux"
import {getRdSurveys} from "@src/views/rds/surveys/store/actions"
import SurveyCard from "@src/views/rds/surveys/SurveyCard"

/**
 * Grid of S2B surveys for the logged-in RD.
 * `limit` caps the cards shown (dashboard) and adds a "View all" link.
 * With `hideWhenEmpty`, nothing renders when there are no surveys (dashboard).
 */
const SurveyGrid = ({title, limit, hideWhenEmpty}) => {
    const dispatch = useDispatch()
    const {rdSurveysLoading, rdSurveysFullFill, rdSurveysError} = useSelector((store) => store.rdSurveys)

    useEffect(() => {
        dispatch(getRdSurveys())
    }, [])

    const surveys = rdSurveysFullFill?.data || []
    const shown = limit ? surveys.slice(0, limit) : surveys

    if (rdSurveysLoading && !rdSurveysFullFill) {
        return hideWhenEmpty ? null : (
            <div className="d-flex justify-content-center" style={{height: '200px'}}>
                <div className="align-self-center"><Spinner color='primary'/></div>
            </div>
        )
    }

    if (surveys.length === 0) {
        if (hideWhenEmpty) return null
        return (
            <div className="text-center text-muted py-5">
                {rdSurveysError ? "We couldn't load surveys right now. Please refresh the page." : "There are no paid surveys for you right now. Check back soon!"}
            </div>
        )
    }

    return (
        <>
            {title && (
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h3 className="mb-0">{title}</h3>
                    {limit && surveys.length > limit && (
                        <Link to="/dashboard/rd/surveys">View all ({surveys.length})</Link>
                    )}
                </div>
            )}
            <div className="brandSlides">
                <Row className="match-height">
                    {shown.map((survey) => (
                        <Col sm="6" md="4" lg="3" key={survey.survey_id} className="mb-4">
                            <SurveyCard survey={survey}/>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    )
}

SurveyGrid.propTypes = {
    title: PropTypes.string,
    limit: PropTypes.number,
    hideWhenEmpty: PropTypes.bool
}

export default SurveyGrid
